// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1u9a8","label":"Labeled_label__1ryLC","divider":"Labeled_divider__32oHT"};